import * as React from 'react';
import { ArticleHeading1, ArticleHeading2, useDeviceType, UIText1 } from '@cian/ui-kit';

import * as style from './styles.css';

export interface INoReviewsProps {
  newbuildingName: string;
  newReviewButton: React.ReactElement;
  newQuestionButton: React.ReactElement;
}

export const NoReviews: React.FC<INoReviewsProps> = ({ newbuildingName, newReviewButton, newQuestionButton }) => {
  const deviceType = useDeviceType();

  const Heading = deviceType === 'desktop' ? ArticleHeading1 : ArticleHeading2;

  return (
    <div data-testid="NoReviews" className={style['container']}>
      <div className={style['content']}>
        <div className={style['image']} />
        <Heading data-testid="NoReviewsTitle">
          Ваш вопрос или отзыв <br />о ЖК «{newbuildingName}» будет&nbsp;первым
        </Heading>
        <div className={style['description']}>
          <UIText1>Оцените ЖК — помогите&nbsp;другим с выбором</UIText1>
        </div>
        <div className={style['controls']}>
          {newReviewButton} {newQuestionButton}
        </div>
      </div>
    </div>
  );
};
